import {
  TEMPLATE_ID_BASE_SHARED_STRUCTURE,
  TEMPLATE_ID_DUAL_SHARE_CLASS,
  TEMPLATE_ID_LONG_TERM_VALUE_FUND,
  TEMPLATE_ID_OMIT_ETHIK_KONTROVERSE,
} from './templateConstants';
import {
  PVM_GPS_DEFAULT_TITLE_ADDITION,
  TEMPLATE_ID_PVM_GPS,
} from '../69d0c43f5a2b1c0d9e8f7a6b/templateConstants';

type ShareClassColumnLabel = { label?: string };

/** Default share-class suffix in header (`| T + A`) — empty for ETFs. */
export const DEFAULT_TITLE_ADDITION_BY_TEMPLATE: Record<string, string> = {
  [TEMPLATE_ID_BASE_SHARED_STRUCTURE]: '',
  [TEMPLATE_ID_DUAL_SHARE_CLASS]: 'T + A',
  [TEMPLATE_ID_OMIT_ETHIK_KONTROVERSE]: 'R',
  [TEMPLATE_ID_LONG_TERM_VALUE_FUND]: '',
  [TEMPLATE_ID_PVM_GPS]: PVM_GPS_DEFAULT_TITLE_ADDITION,
};

/** Extract share-class letter/suffix from column label (e.g. "Anteilklasse T" → "T"). */
export function extractShareClassSuffix(label: string): string {
  const trimmed = label.trim();
  const match = trimmed.match(/Anteilklasse\s+(.+)$/i);
  if (match?.[1]) return match[1].trim();
  const parts = trimmed.split(/\s+/);
  return parts[parts.length - 1] || trimmed;
}

/** Build header suffix from share-class column labels (e.g. T + A). */
export function deriveTitleAdditionFromShareClassColumns(
  columns?: Array<ShareClassColumnLabel> | null,
): string {
  if (!Array.isArray(columns) || columns.length === 0) return '';
  const suffixes = columns
    .map((col) => extractShareClassSuffix(String(col?.label || '')))
    .filter(Boolean);
  if (!suffixes.length) return '';
  if (suffixes.length === 1) return suffixes[0];
  return suffixes.join(' + ');
}

/**
 * Resolve header share-class suffix (`title_addition`).
 * Uses stored value when set; otherwise derives from share-class columns or template default.
 */
export function resolveTitleAddition(
  templateId?: string,
  stored?: string | null,
  shareClassColumns?: Array<ShareClassColumnLabel> | null,
): string {
  const trimmed = stored?.trim();
  if (trimmed) return trimmed;

  if (templateId === TEMPLATE_ID_DUAL_SHARE_CLASS) {
    const derived = deriveTitleAdditionFromShareClassColumns(shareClassColumns);
    if (derived) return derived;
  }

  return DEFAULT_TITLE_ADDITION_BY_TEMPLATE[templateId ?? ''] ?? '';
}
